// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1__Gl","cls2":"LoswpPackPitch-cls2_u_l LoswpPackPitch-cls1__Gl"};